import { Box, Grid } from '@mui/material'
import Label from 'components/Label'
import { TabPersonalDataContent } from 'components/TabTeenager/TabPersonalDataContent'
import { useNavigate, useParams } from 'react-router-dom'
import React from 'react'
import EditRoundedIcon from '@mui/icons-material/EditRounded'
import { teenagerRecordFunctionalities } from 'utils/helpers/funcionalidades'
import { useAuthContext } from 'contexts/auth.context'
import { TabTeenagerProps } from '../..'
import Button from '@mui/material/Button'

export const TabPersonalData: React.FC<TabTeenagerProps> = ({ data }) => {
  const navigate = useNavigate()
  const { id } = useParams()

  const { handleHasPermission } = useAuthContext()

  return (
    <Grid container spacing={2}>
      <Grid
        item
        xs={12}
        display='flex'
        sx={{
          width: '100%',
          flexDirection: {
            md: 'row',
            sm: 'column-reverse',
            xs: 'column-reverse',
          },
          justifyContent: {
            md: 'space-between',
            sm: 'none',
            xs: 'none',
          },
        }}
      >
        <Label text='Identificação' color='primary' v='h6' bold />
        {handleHasPermission(teenagerRecordFunctionalities.editar) && (
          <Box
            sx={{
              marginBottom: {
                xs: '1rem',
                sm: '1rem',
                md: '0rem',
              },
            }}
          >
            <Button
              startIcon={<EditRoundedIcon />}
              color='primary'
              variant={'contained'}
              aria-label='visualize'
              onClick={() => navigate(`/ficha-adolescente/${id}/editar`)}
            >
              Editar Ficha
            </Button>
          </Box>
        )}
      </Grid>
      <Grid item xs={12}>
        {data && data.identAdolescente ? (
          <TabPersonalDataContent data={data.identAdolescente} isVisualize={true} />
        ) : null}
      </Grid>
    </Grid>
  )
}
